import * as actionTypes from './actionTypes';

export const setIsOffline = (isOffline) => ({
  type: actionTypes.SET_IS_OFFLINE,
  isOffline,
});

export const connectionChange = (isOffline) => ({
  type: actionTypes.CONNECTION_CHANGE,
  isOffline,
});

export const cacheDocumentOffline = (document, password = null) => ({
  type: actionTypes.CACHE_DOCUMENT,
  document,
  password,
});
export const cacheDocumentOfflineSuccess = (document) => ({
  type: actionTypes.CACHE_DOCUMENT_SUCCESS,
  document,
});
export const cacheDocumentOfflinePasswordIncorrect = (document) => ({
  type: actionTypes.CACHE_DOCUMENT_PASSWORD_INCORRECT,
  document,
});


export const cacheDocumentsOffline = (documents, password = null) => ({
  type: actionTypes.CACHE_DOCUMENTS,
  documents,
  password,
});
export const cacheDocumentsOfflineAbort = () => ({
  type: actionTypes.CACHE_DOCUMENTS_ABORT,
});
export const cacheDocumentsOfflineSuccess = (documents) => ({
  type: actionTypes.CACHE_DOCUMENTS_SUCCESS,
  documents,
});


export const uncacheDocumentOffline = (document) => ({
  type: actionTypes.UNCACHE_DOCUMENT,
  document,
});
export const uncacheDocumentOfflineSuccess = (document) => ({
  type: actionTypes.UNCACHE_DOCUMENT_SUCCESS,
  document,
});


export const addOfflineWaitingForSyncId = (id) => ({
  type: actionTypes.ADD_WAITING_FOR_SYNC_ID,
  id,
});
export const removeOfflineWaitingForSyncId = (id) => ({
  type: actionTypes.REMOVE_WAITING_FOR_SYNC_ID,
  id,
});

export const addOfflineSyncErrorId = (id) => ({
  type: actionTypes.ADD_SYNC_ERROR_ID,
  id,
});
export const removeOfflineSyncErrorId = (id) => ({
  type: actionTypes.REMOVE_SYNC_ERROR_ID,
  id,
});


export const addOfflineStorageErrorId = (id) => ({
  type: actionTypes.ADD_STORAGE_ERROR_ID,
  id,
});


export const syncOfflineChanges = () => ({
  type: actionTypes.SYNC_OFFLINE_CHANGES,
});
export const syncOfflineChangesSuccess = () => ({
  type: actionTypes.SYNC_OFFLINE_CHANGES_SUCCESS,
});
